import { Block, Inline } from '@/components/crRender'
import { CardRowProps } from '../types'
import { useTranslation } from "react-i18next"

const CardRow: React.FC<CardRowProps> = ({ title, data, dataClassName = 'request-details', cardClassName, onClick, isRender = true, className = '' }) => {
 
  const { t } = useTranslation()

  return (
    <Block isRender={isRender} className={`${cardClassName} ${className}`} onClick={() => onClick?.()}>
      <Inline isRender={!!title} className='boldName'>{t(title)} :</Inline> <span className={dataClassName}>{data}</span>
    </Block>
  )
}

export default CardRow

